import { Link } from "react-router-dom";
import { AlertCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background text-foreground grain flex items-center justify-center px-6">
      <div className="w-full max-w-lg bg-card border border-border clip-frame p-10 text-center" data-testid="payment-cancel-page">
        <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center mb-6">
          <AlertCircle className="w-8 h-8 text-primary" />
        </div>
        <h1 className="font-serif text-4xl text-foreground mb-3">Booking not completed</h1>
        <p className="text-muted-foreground font-light mb-8 max-w-md mx-auto">
          Your booking is on hold and no deposit was charged. Your slot may still be available — pick up where you left off.
        </p>
        <Link to="/#book" className="inline-flex items-center gap-2 px-8 py-3 bg-primary text-primary-foreground text-sm tracking-wide hover:bg-primary/90 transition-colors clip-frame">
          <ArrowLeft className="w-4 h-4" /> Back to booking
        </Link>
      </div>
    </div>
  );
}
